import {
  CREATE_AGREEMENT,
  CREATE_AGREEMENT_ERROR,
  CREATE_AGREEMENT_SUCCESS,
  DOWNLOAD_AGREEMENT_SUCCESS,
  DOWNLOAD_AGREEMENT,
  DOWNLOAD_AGREEMENT_ERROR,
  DOWNLOAD_PDF_AGREEMENT,
  DOWNLOAD_PDF_AGREEMENT_SUCCESS,
  DOWNLOAD_PDF_AGREEMENT_ERROR,
} from './agreementActionConstants';

// Create Agreement
export const createAgreement = (payload) => ({
  type: CREATE_AGREEMENT,
  payload,
});

export const createAgreementSuccess = (payload) => ({
  type: CREATE_AGREEMENT_SUCCESS,
  payload,
});

export const createAgreementError = (payload) => ({
  type: CREATE_AGREEMENT_ERROR,
  payload,
});

// Download Agreement
export const downloadAgreement = (payload) => ({
  type: DOWNLOAD_AGREEMENT,
  payload,
});

export const downloadAgreementSuccess = (payload) => ({
  type: DOWNLOAD_AGREEMENT_SUCCESS,
  payload,
});

export const downloadAgreementError = (payload) => ({
  type: DOWNLOAD_AGREEMENT_ERROR,
  payload,
});

// Download pdf Agreement
export const downloadPdfAgreement = (payload) => ({
  type: DOWNLOAD_PDF_AGREEMENT,
  payload,
});

export const downloadPdfAgreementSuccess = (payload) => ({
  type: DOWNLOAD_PDF_AGREEMENT_SUCCESS,
  payload,
});

export const downloadPdfAgreementError = (payload) => ({
  type: DOWNLOAD_PDF_AGREEMENT_ERROR,
  payload,
});
